import { useEffect, useState } from "react";
import { PageHeader } from "antd";
import LayoutCss from "layout/layout.module.scss";
import K from "utilities/constants";
import User from "redux/models/user";
import { useSelector } from "react-redux";
import { selectUserId } from "redux/slices/userSlice";
import { DataTableLayout } from "../../common/components/dataTableLayout/dataTableLayout";
import { ClientSideDataGrid } from "../../common/components/clientSideDataGrid/clientSideDataGrid";
import { usePageFilter } from "../../hooks/usePageFilters";
import { getColumns } from "./columns";

export default function Logs() {
  const userId = useSelector(selectUserId);
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = usePageFilter("logs_search");

  useEffect(() => {
    (async () => {
      try {
        const body = null;
        const res = await User.getLogs(body);
        setLogs(res);
      } catch (err) {
        console.error(err);
      }
    })();
  }, []);

  return (
    <>
      <PageHeader
        title="User Logs"
        ghost={false}
        className={LayoutCss.appPageHeader}
      />

      <DataTableLayout searchDefaultValue={search} onSearchChange={setSearch}>
        <ClientSideDataGrid
          userId={userId}
          configKey={K.AgGridTable.Keys.LogsVisibleColumn}
          defaultColumnConfig={getColumns()}
          rowData={logs ?? []}
          quickFilterText={search}
        />
      </DataTableLayout>
    </>
  );
}
